/**
 * Created by Administrator on 2019/10/7.
 */
import { request } from '../utils/request'
import serviceInterface from '../api/serviceInterface'

/**
 * 获取下载订单历史
 * @param params
 * @returns {*|Promise|Promise<unknown>|undefined}
 */
export const getConsumeList = (params) => {
    return request({
        url: serviceInterface.order.consumeList,
        params: params
    })
}


/**
 * 获取充值历史订单
 * @param params
 * @returns {*|Promise|Promise<unknown>|undefined}
 */
export const getChargeList = (params) => {
    return request({
        url: serviceInterface.order.chargeList,
        params: params
    })
}


/**
 * 获取购物车列表
 * @param params
 * @returns {*|Promise|Promise<unknown>|undefined}
 */
 export const cartsList = (params) => {
    return request({
        url: serviceInterface.order.cartsList,
        params: params
    })
}


/**
 * 添加到购物车列表
 * @param params
 * @returns {*|Promise|Promise<unknown>|undefined}
 */
 export const addCarts = (params) => {
    return request({
        url: serviceInterface.order.addCarts,
        params: params
    })
}

/**
 * 删除购物车列表
 * @param params
 * @returns {*|Promise|Promise<unknown>|undefined}
 */
 export const delCarts = (params) => {
    return request({
        url: serviceInterface.order.delCarts,
        params: params
    })
}

/**
 * 删除购物车列表byRec
 * @param params
 * @returns {*|Promise|Promise<unknown>|undefined}
 */
 export const delCartsByRec = (params) => {
    return request({
        url: serviceInterface.order.delCartsByRec,
        params: params
    })
}

/**
 * 判断是否在购物车列表
 * @param params
 * @returns {*|Promise|Promise<unknown>|undefined}
 */
 export const hasCarts = (params) => {
    return request({
        url: serviceInterface.order.hasCarts,
        params: params
    })
}